"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _has = _interopRequireDefault(require("lodash/fp/has"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _debounce = _interopRequireDefault(require("lodash/fp/debounce"));
var _memoLast = _interopRequireDefault(require("@active/react-utils/componentUtils/memoLast"));
var _validateAddress = _interopRequireDefault(require("@active/core/address/validateAddress"));
var _Input = _interopRequireDefault(require("@active/react-ui/Input"));
var _ResponsiveDropdown = _interopRequireDefault(require("@active/react-ui/ResponsiveDropdown"));
var _i18n = require("@active/react-utils/i18n");
var _PostalCodeInput = _interopRequireWildcard(require("./PostalCodeInput"));
var _parseForRender2 = _interopRequireDefault(require("../utils/parseForRender"));
var _fetchCountryConfig = _interopRequireDefault(require("../services/fetchCountryConfig"));
var _createAVS = _interopRequireDefault(require("../services/createAVS"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TEXT_FIELD_MAX_LENGTH = 255;
var FIELD_PREFIX = 'addressForm.addressField';
var VALIDATE_MAP = {};
var withValidation = function withValidation(regex) {
  if (!regex) return undefined;
  if (!VALIDATE_MAP[regex]) {
    VALIDATE_MAP[regex] = function (value) {
      return new RegExp(regex).test(value) ? undefined : 'react-ui.validation.invalid';
    };
  }
  return VALIDATE_MAP[regex];
};
var getAddressFieldConfig = (0, _memoLast["default"])(function () {
  for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
    _ref[_key] = arguments[_key];
  }
  var countriesConfig = _ref[0],
    country = _ref[1];
  var countryConfig = countriesConfig[country];
  if (!countryConfig) {
    countryConfig = countriesConfig.US;
  }
  if (!(0, _has["default"])('addressForm')(countryConfig)) {
    return {};
  }
  var addressFields = (0, _prop["default"])('addressForm.addressFields')(countryConfig) || [];
  var configs = Object.values(addressFields);
  return Object.keys(addressFields).reduce(function (acc, cur) {
    var addressField = addressFields[cur];
    var addressPart = addressField.addressPart,
      position = addressField.position;
    var mixed = configs.filter(function (c) {
      return c.addressPart === addressPart;
    }).length > 1;
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, mixed ? "".concat(addressPart).concat(position) : addressPart, _objectSpread(_objectSpread({}, addressField), {}, {
      mixed: mixed
    })));
  }, {});
});
var getField = function getField(position, fieldName, countryCode) {
  return (0, _memoLast["default"])(function (fieldValue, addressConfig, countryConfig, i18n, onFieldChange) {
    var addressField = addressConfig[fieldName];
    var addressPart = addressField.addressPart,
      required = addressField.required,
      validationRegex = addressField.validationRegex,
      options = addressField.options,
      mixed = addressField.mixed;
    var label = "".concat(FIELD_PREFIX, ".").concat(countryCode, ".").concat(addressPart).concat(position > 1 ? ".".concat(position) : '');
    var field = {
      name: fieldName,
      value: fieldValue,
      label: i18n(label) !== label ? label : "".concat(FIELD_PREFIX, ".").concat(addressPart),
      component: _Input["default"],
      required: required,
      validate: withValidation(validationRegex),
      onChange: onFieldChange(addressPart, position, mixed)
    };
    if (options && options.length > 0) {
      field = _objectSpread(_objectSpread({}, field), {}, {
        component: _ResponsiveDropdown["default"],
        data: options.map(function (option) {
          return {
            text: i18n("".concat(addressPart, ".displayName.").concat(countryCode, ".").concat(option.fieldOptionValue)),
            value: option.fieldOptionValue
          };
        })
      });
    } else {
      field = _objectSpread(_objectSpread({}, field), {}, {
        maxLength: TEXT_FIELD_MAX_LENGTH
      });
    }
    if (addressPart === _PostalCodeInput.POSTAL_CODE_FIELD_KEY) {
      field = _objectSpread(_objectSpread({}, field), {}, {
        countryConfig: countryConfig,
        component: _PostalCodeInput["default"]
      });
    }
    return field;
  });
};
var getFieldValue = function getFieldValue(fieldValue) {
  return function () {
    var _ref2;
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return (_ref2 = fieldValue && fieldValue.split('\n')[position - 1]) !== null && _ref2 !== void 0 ? _ref2 : '';
  };
};
function getFields(address, i18n, countriesConfig, fieldGetters, onFieldChange) {
  var countryConfig = countriesConfig[address.country];
  if (!countryConfig) {
    countryConfig = countriesConfig.US;
  }
  if (!(0, _has["default"])('addressForm')(countryConfig)) {
    return [];
  }
  var code = countryConfig.iso3166Code;
  var addressFieldConfig = getAddressFieldConfig(countriesConfig, address.country);
  var fields = Object.keys(addressFieldConfig).reduce(function (acc, cur) {
    var addressField = addressFieldConfig[cur];
    var addressPart = addressField.addressPart,
      position = addressField.position;
    var fieldGetterKey = "".concat(code, "_").concat(cur, "_").concat(position);
    if (!fieldGetters.has(fieldGetterKey)) {
      fieldGetters.set(fieldGetterKey, getField(position, cur, code));
    }
    var field = fieldGetters.get(fieldGetterKey)(getFieldValue((0, _prop["default"])(addressPart)(address))(position), addressFieldConfig, countryConfig, i18n, onFieldChange);
    return [].concat((0, _toConsumableArray2["default"])(acc), [field]);
  }, []);
  return fields;
}
function useAddress(addressConfig) {
  var avs = addressConfig.avs,
    name = addressConfig.name,
    value = addressConfig.value,
    onChange = addressConfig.onChange,
    autoCorrect = addressConfig.autoCorrect,
    onFieldValueChange = addressConfig.onFieldValueChange,
    onCorrect = addressConfig.onCorrect,
    onFieldTouch = addressConfig.onFieldTouch,
    countriesConfigFromProp = addressConfig.countriesConfig,
    extendCorrectionRequest = addressConfig.extendCorrectionRequest;
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  var address = (0, _react.useMemo)(function () {
    return (0, _parseForRender2["default"])(value !== null && value !== void 0 ? value : {});
  }, [value]);
  var fieldGetters = (0, _react.useMemo)(function () {
    return new Map();
  }, []);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    countries = _useState2[0],
    setCountries = _useState2[1];
  var _useState3 = (0, _react.useState)(countriesConfigFromProp !== null && countriesConfigFromProp !== void 0 ? countriesConfigFromProp : {}),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    countriesConfig = _useState4[0],
    setCountriesConfig = _useState4[1];
  var hideZipPlus4 = (0, _react.useCallback)(function () {
    var _parseForRender = (0, _parseForRender2["default"])(value || {}),
      postalCode = _parseForRender.postalCode;
    return postalCode;
  }, [value]);
  var correct = (0, _react.useCallback)(function () {
    if (!avs) {
      throw new Error('`avs` endpoint must be provided for address correction.');
    }
    if (!(0, _validateAddress["default"])(countriesConfig)(address)) {
      return Promise.resolve({
        isCorrect: false,
        source: {},
        correction: {},
        error: {
          description: 'Address Not Found'
        }
      });
    }
    if (address.country !== 'US') {
      return Promise.resolve({
        isCorrect: true,
        source: address,
        correction: address
      });
    }
    return (0, _createAVS["default"])({
      url: avs
    }).correct(address, extendCorrectionRequest);
  }, [avs, address, countriesConfig, extendCorrectionRequest]);
  var handleAutoCorrect = (0, _react.useMemo)(function () {
    return (0, _debounce["default"])(200, /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(addressToCorrect) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!autoCorrect || !onCorrect)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(addressToCorrect.country !== 'US')) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if ((0, _validateAddress["default"])(countriesConfig)(addressToCorrect)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              _context.next = 9;
              return (0, _createAVS["default"])({
                url: avs
              }).correct(addressToCorrect, extendCorrectionRequest);
            case 9:
              result = _context.sent;
              onCorrect(result);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              console.warn(_context.t0); // eslint-disable-line no-console
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 13]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
  }, [avs, onCorrect, autoCorrect, countriesConfig, extendCorrectionRequest]);
  var onFieldChange = (0, _react.useCallback)(function (field, position, mixed) {
    return function (event) {
      var fieldName = "".concat(name, ".").concat(field);
      var newAddress = _objectSpread(_objectSpread({}, value), {}, (0, _defineProperty2["default"])({}, field, (0, _prop["default"])('target.value')(event)));
      if (mixed) {
        var previousValue = (0, _prop["default"])(field)(value) || '';
        var valueToSet = previousValue.split('\n');
        valueToSet[position - 1] = (0, _prop["default"])('target.value')(event);
        var fieldValue = valueToSet.join('\n');
        onFieldValueChange === null || onFieldValueChange === void 0 || onFieldValueChange(fieldName, fieldValue);
        newAddress = _objectSpread(_objectSpread({}, newAddress), {}, (0, _defineProperty2["default"])({}, field, fieldValue));
      }
      if (field !== 'postalCode' && field !== 'country') {
        var postalCode = hideZipPlus4();
        onFieldValueChange === null || onFieldValueChange === void 0 || onFieldValueChange("".concat(name, ".postalCode"), postalCode, false);
        newAddress = _objectSpread(_objectSpread({}, newAddress), {}, {
          postalCode: postalCode
        });
      }
      if (address.country === 'US' && field === 'postalCode') {
        var _newAddress;
        onFieldValueChange === null || onFieldValueChange === void 0 || onFieldValueChange(fieldName, (_newAddress = newAddress) === null || _newAddress === void 0 || (_newAddress = _newAddress.postalCode) === null || _newAddress === void 0 ? void 0 : _newAddress.split('-')[0]);
      }
      if (autoCorrect) {
        handleAutoCorrect(newAddress);
      }
      onChange && onChange();
    };
  }, [name, value, address.country, autoCorrect, onChange, onFieldValueChange, hideZipPlus4, handleAutoCorrect]);
  var fields = (0, _react.useMemo)(function () {
    if ((0, _isEmpty["default"])(countriesConfig)) return [];
    return getFields(address, i18n, countriesConfig, fieldGetters, onFieldChange);
  }, [countriesConfig, i18n, fieldGetters, address, onFieldChange]);
  var onCountryChange = (0, _react.useCallback)(function (country) {
    if (country === (value === null || value === void 0 ? void 0 : value.country)) {
      return;
    }
    fieldGetters.clear();
    var previousValue = value !== null && value !== void 0 ? value : {};
    onFieldValueChange === null || onFieldValueChange === void 0 || onFieldValueChange("".concat(name, ".country"), country);
    onFieldTouch === null || onFieldTouch === void 0 || onFieldTouch("".concat(name, ".country"), false);
    Object.keys((0, _omit["default"])('country')(previousValue)).forEach(function (key) {
      onFieldValueChange === null || onFieldValueChange === void 0 || onFieldValueChange("".concat(name, ".").concat(key), '', false);
      onFieldTouch === null || onFieldTouch === void 0 || onFieldTouch("".concat(name, ".").concat(key), false);
    });
    onChange && onChange();
  }, [onFieldTouch, name, onChange, value, fieldGetters, onFieldValueChange]);
  (0, _react.useEffect)(function onMount() {
    if ((0, _isEmpty["default"])(countriesConfig)) {
      (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var config;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _fetchCountryConfig["default"])();
            case 2:
              config = _context2.sent;
              setCountriesConfig(config);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function onCountiresConfigUpdate() {
    if (!(0, _isEmpty["default"])(countriesConfig)) {
      setCountries((0, _memoLast["default"])(function () {
        for (var _len2 = arguments.length, _ref5 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          _ref5[_key2] = arguments[_key2];
        }
        var i18nFromParams = _ref5[0],
          countriesConfigFromParams = _ref5[1];
        return Object.keys(countriesConfigFromParams).map(function (country) {
          return {
            text: i18nFromParams("country.displayName.".concat(country)),
            value: country
          };
        });
      })(i18n, countriesConfig));
    }
  }, [countriesConfig, i18n]);
  (0, _react.useEffect)(function onCountriesConfigFromPropsChange() {
    if (!(0, _isEmpty["default"])(countriesConfigFromProp)) {
      setCountriesConfig(countriesConfigFromProp);
    }
  }, [countriesConfigFromProp]);
  return {
    fields: fields,
    address: address,
    countries: countries,
    onCountryChange: onCountryChange,
    correct: correct
  };
}
var _default = exports["default"] = useAddress;